module.exports = __webpack_public_path__ + "img/insurita-faqs-top.c44353ea.svg";